import { InfiniteData, QueryClient, QueryKey } from '@tanstack/react-query';
import { Post, ReactionType, Reply } from '../../../../generated/graphql';

type Entity = Reply | Post;

export const toggleReaction =
  (entityId: string, type: ReactionType) => (entity: Entity) => {
    if (entity.id === entityId) {
      const toggledReaction = entity.reactions.find((i) => i.type === type);
      if (toggledReaction) {
        const otherReactions = entity.reactions.filter((i) => i.type !== type);
        if (toggledReaction.isToggled && toggledReaction.count === 1) {
          return {
            ...entity,
            reactions: [...otherReactions],
          };
        }
        return {
          ...entity,
          reactions: [
            ...otherReactions,
            {
              ...toggledReaction,
              isToggled: !toggledReaction.isToggled,
              count: toggledReaction.isToggled
                ? toggledReaction.count - 1
                : toggledReaction.count + 1,
            },
          ],
        };
      }
      return {
        ...entity,
        reactions: [
          ...entity.reactions,
          {
            type,
            count: 1,
            isToggled: true,
          },
        ],
      };
    }
    return entity;
  };

type UpdateReactionOnListInput = {
  entityId: string;
  queryClient: QueryClient;
  queryKey: QueryKey;
  type: ReactionType;
};

export const updateReactionOnList = ({
  entityId,
  queryClient,
  queryKey,
  type,
}: UpdateReactionOnListInput) => {
  queryClient.setQueryData<InfiniteData<Reply[] | Post[]>>(
    queryKey,
    // @ts-ignore
    (previousData) => {
      if (previousData?.pages && Array.isArray(previousData?.pages)) {
        return {
          ...previousData,
          pages: previousData.pages.map((page) =>
            page.map(toggleReaction(entityId, type)),
          ),
        };
      }
      return previousData;
    },
  );
};

type UpdateReactionOnEntityInput = {
  entityId: string;
  queryClient: QueryClient;
  queryKey: QueryKey;
  type: ReactionType;
};

export const updateReactionOnEntity = ({
  entityId,
  queryClient,
  queryKey,
  type,
}: UpdateReactionOnEntityInput) => {
  const item = queryClient.getQueryData(queryKey);
  if (item) {
    queryClient.setQueryData(queryKey, (previousData) => {
      // @ts-ignore
      return toggleReaction(entityId, type)(previousData);
    });
  }
};
